//pc端路由引入
import Vue from 'vue'
import Router from 'vue-router'
import Home from '../pages/pcPages/Home.vue'
import Enter from '../pages/pcPages/Enter.vue'
import Children from '../pages/pcPages/Children.vue'
import Notice from '../pages/pcPages/Notice.vue'
import School from '../pages/pcPages/School.vue'
import Caucus from '../pages/pcPages/Caucus.vue'
import Recruit from '../pages/pcPages/Recruit.vue'
import Contact from '../pages/pcPages/Contact.vue'
import NewsDetail from '../pages/pcPages/NewsDetail.vue'

//移动端路由引入
import Index from '../pages/mbPages/Index.vue'
import mHeader from '../pages/mbPages/mHeader.vue'
import mEnter from '../pages/mbPages/mEnter.vue'
import mChildren from '../pages/mbPages/mChildren.vue'
import mNotice from '../pages/mbPages/mNotice.vue'
import mSchool from '../pages/mbPages/mSchool.vue'
import mRecruit from '../pages/mbPages/mRecruit.vue'
import mCaucus from '../pages/mbPages/mCaucus.vue'
import mContact from '../pages/mbPages/mContact.vue'
import mDetail from '../pages/mbPages/mDetail.vue'

// 后台路由
import backLogin from '../pages/backPages/login.vue'
import backHome from '../pages/backPages/home.vue'
import welcome from '../pages/backPages/welcome.vue'
import backVideo from '../pages/backPages/video.vue'
import backContact from '../pages/backPages/contact.vue'
import backJoin from '../pages/backPages/join.vue'
import backSEO from '../pages/backPages/SEO.vue'
import backChongyi from '../pages/backPages/chongyi.vue'
import backChildren from '../pages/backPages/children.vue'
import backPatriarch from '../pages/backPages/patriarch.vue'
import backPolitical from '../pages/backPages/political.vue'
import backInform from '../pages/backPages/inform.vue'
import backNews from '../pages/backPages/news.vue'
import backRecipe from '../pages/backPages/recipe.vue'
import backRecruit from '../pages/backPages/recruit.vue'
import backBanner from '../pages/backPages/banner.vue'
import services from '../pages/backPages/services.vue'
import newtype from '../pages/backPages/newtype.vue'
import backCaseAdd from '../pages/backPages/caseAdd.vue'
import backCaseEdit from '../pages/backPages/caseEdit.vue'

//大树官网路由
import Ahome from '../pages/pcPages/Ahome.vue'
import Aabout from '../pages/pcPages/Aabout.vue'
import Aservice from '../pages/pcPages/Aservice.vue'
import Ainnovate from '../pages/pcPages/Ainnovate.vue'
import Ajoin from '../pages/pcPages/Ajoin.vue'
import Anew from '../pages/pcPages/Anew.vue'
import Anews from '../pages/pcPages/Anews.vue'

Vue.use(Router)

export default new Router({
  routes: [
    //pc端路由表
    {
      path: '/',
      component: Ahome
    },
    {
      path: '/Ahome',
      name: 'Ahome',
      component: Ahome
    },
    {
      path: '/Aabout',
      name: 'Aabout',
      component: Aabout
    },
    {
      path: '/Aservice',
      name: 'Aservice',
      component: Aservice
    },
    {
      path: '/Ainnovate',
      name: 'Ainnovate',
      component: Ainnovate
    },
    {
      path: '/Ajoin',
      name: 'Ajoin',
      component: Ajoin
    },
    {
      path: '/Anew',
      name: 'Anew',
      component: Anew
    },
    {
      path: '/Anews',
      name: 'Anews',
      component: Anews
    },

    {
      // path: '/',
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      // path: '/',
      path: '/Enter',
      component: Enter
    },
    {
      path: '/Enter',
      name: 'Enter',
      component: Enter
    },
    {
      path:'/Children',
      name:'Children',
      component:Children
    },
    {
      path:'/Notice',
      name:'Notice',
      component:Notice
    },
    {
      path:'/School',
      name:'School',
      component:School

    },
    {
      path:'/Recruit',
      name:'Recruit',
      component:Recruit
    },
    {
      path:'/Caucus',
      name:'Caucus',
      component:Caucus
    }, 
    {
      path:'/Contact',
      name:'Contact',
      component:Contact
    },
    {
      path:'/NewsDetail',
      name:'NewsDetail',
      component:NewsDetail
    },
    // 移动端路由表
    {
      path:'/Index',
      name:'Index',
      component:Index
    },
    {
      path: '/mHeader',
      name: 'mHeader',
      component: mHeader,
      children: [
        {
          path: '/',
          // name: 'mEnter',
          component: mEnter
        },
        {
          path: '/mEnter',
          name: 'mEnter',
          component: mEnter
        },
        {
          path: '/mChildren',
          name: 'mChildren',
          component: mChildren
        },
        {
          path: '/mNotice',
          name: 'mNotice',
          component: mNotice
        },
        {
          path: '/mSchool',
          name: 'mSchool',
          component: mSchool
        },
        {
          path: '/mRecruit',
          name: 'mRecruit',
          component: mRecruit
        },
        {
          path: '/mCaucus',
          name: 'mCaucus',
          component: mCaucus
        },
        {
          path: '/mContact',
          name: 'mContact',
          component: mContact
        },
        {
          path: '/mDetail',
          name: 'mDetail',
          component: mDetail
        }
      ]
    },
    // 后台路由
    {
      // path: '/',
      path: '/backLogin',
      name: 'backLogin',
      component: backLogin
    },
    {
      path: '/backHome',
      name: 'backHome',
      component: backHome,
      redirect: {path: '/welcome'},
      children: [
        {
          path: '/welcome',
          name: 'welcome',
          component: welcome
        },
        {
          path: '/backVideo',
          name: 'backVideo',
          component: backVideo
        },
        {
          path: '/backContact',
          name: 'backContact',
          component: backContact
        },
        {
          path: '/backJoin',
          name: 'backJoin',
          component: backJoin
        },
        {
          path: '/backSEO',
          name: 'backSEO',
          component: backSEO
        },
        {
          path: '/backChongyi',
          name: 'backChongyi',
          component: backChongyi
        },
        {
          path: '/backChildren',
          name: 'backChildren',
          component: backChildren
        },
        {
          path: '/backPatriarch',
          name: 'backPatriarch',
          component: backPatriarch
        },
        {
          path: '/backPolitical',
          name: 'backPolitical',
          component: backPolitical
        },
        {
          path: '/backInform',
          name: 'backInform',
          component: backInform
        },
        {
          path: '/backNews',
          name: 'backNews',
          component: backNews
        },
        {
          path: '/backRecipe',
          name: 'backRecipe',
          component: backRecipe
        },
        {
          path: '/backRecruit',
          name: 'backRecruit',
          component: backRecruit
        },
        {
          path: '/backBanner',
          name: 'backBanner',
          component: backBanner
        },
        {
          path: '/services',
          name: 'services',
          component: services
        },
        {
          path: '/newtype',
          name: 'newtype',
          component: newtype
        },
        {
          path: '/backCaseAdd',
          name: 'backCaseAdd',
          component: backCaseAdd
        },
        {
          path: '/backCaseEdit',
          name: 'backCaseEdit',
          component: backCaseEdit
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js